<template>
    <div class="container-fluid">
        <h1>{{category.name}}</h1>
        <div class="card card-body shadow" ref="container">
            <p v-html="category.description"></p>
            <div class="row mt-3">
                <div class="col-sm-12 col-md-4" v-for="item in category.news" :key="'news_item'+item.id+'_'+$store.getters['langStore/current']">
                    <NewsCard :item="item"/>
                </div>
            </div>
            <div class="row mt-5" v-if="hasMore">
                <div class="col-sm-12 text-center">
                    <button class="w-25 btn btn-wos-real" @click="fetch()">
                        {{$t('components.news.btnShowMore')}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NewsApiService from "@/api/news.api";
import {EVENT_LANG_CHANGE} from "@/core/constants";
import NewsCard from "@/components/application/NewsCard";
import {empty} from "@/helpers";

export default {
    name: "NewsCategory",
    components: {NewsCard},
    data() {
        return {
            loader: null,
            hasMore: false,
            offset: 0,
            category: {}
        }
    },

    mounted() {
        this.fetch();

        this.$eventBus.$on(EVENT_LANG_CHANGE, () => {
            this.fetch();
        });
    },

    destroyed() {
        this.$eventBus.$off(EVENT_LANG_CHANGE);
    },

    methods: {
        fetch() {
            this.showLoader();
            NewsApiService.category(this.$route.params.slug, this.offset)
                .then(response => {
                    if (!this.category.news) {
                        this.category = response.data.category;
                    } else {
                        this.category.news = this.category.news.concat(response.data.category.news);
                    }

                    this.hasMore = response.data.hasMore;
                    this.offset = response.data.currentOffset;
                })
                .finally(() => this.hideLoader());
        },

        showLoader: function () {
            if (!empty(this.loader)) {
                this.loader.hide();
                this.loader = null;
            }
            this.loader = this.$loading.show({
                container: this.$refs.container
            });
        },

        hideLoader: function () {
            if (!empty(this.loader)) {
                this.loader.hide();
                this.loader = null;
            }
        }
    },

    computed: {
        categories() {
            return this.items;
        }
    }
}
</script>

<style scoped>

</style>
